import { createGlobalStyle } from "styled-components";
import AvenirNextRegularTTF from "../../src/fonts/avenir-next-regular.ttf";
import AvenirNextRegularWOFF2 from "../../src/fonts/avenir-next-regular.woff2";
import AvenirNextBoldTTF from "../../src/fonts/avenir-next-bold.ttf";
import AvenirNextBoldWOFF2 from "../../src/fonts/avenir-next-bold.woff2";

const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: 'Avenir Next Bold';
    src: local('Avenir Next Bold'), url(${AvenirNextBoldWOFF2}) format('woff2'), url(${AvenirNextBoldTTF}) format('truetype');
    font-weight: 700;
    font-display: swap;
  }


  @font-face {
    font-family: 'Avenir Next';
    src: local('Avenir Next'), url(${AvenirNextRegularWOFF2}) format('woff2'), url(${AvenirNextRegularTTF}) format('truetype');
    font-weight: 400;
    font-display: swap;
  }

  ::-webkit-scrollbar { 
    display: none;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

.main-inner {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 1440px;
  padding: 0 70px;
  margin: 0 auto;

  @media screen and (max-width: 680px) {
    max-width: 100%;
    padding: 0px 16px;
  }
}


`;

export default GlobalStyle;
